export const defaultEntityClassification = 'Other';